<template>
    <v-form @submit.prevent="onSubmit">
        <v-card v-if="isActive">
            <v-card-text>
                У Вас есть активная сессия
                <br/>
                <v-btn class="form-btn form-btn--continue" :to="{name: 'session'}" type="submit" color="primary">Продолжить тестирование</v-btn>
            </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-text>
                <div class="form-title mb-1">У меня есть ключ</div>
                <v-layout>
                    <v-flex>
                        <v-text-field v-model="key" id="key" :disabled="isLoading" :error="isError" :error-messages="errors" prepend-icon="vpn_key" name="text" label="Введите ключ" type="text"></v-text-field>
                    </v-flex>
                    <v-btn class="form-btn form-btn--key" :loading="isLoading" type="submit" color="primary">Войти</v-btn>
                </v-layout>

                <div class="form-title mb-1 mt-2">У меня нет ключа</div>
                <v-btn class="form-btn form-btn--free" :loading="isLoadingWithoutKey" @click="withoutKey" color="primary">Хочу оценить собственные способности</v-btn>
            </v-card-text>
        </v-card>
    </v-form>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        components: {},
        data: () => ({
            key: '',
            isLoading: false,
            isLoadingWithoutKey: false,
            errors: []
        }),
        props: {},
        computed: {
            ...mapGetters('auth', ['isActive']),

            isError () {
                return !!this.errors.length
            }
        },
        methods: {
            onSubmit () {
                if (this.isLoading) return
                if (!this.key) {
                    this.errors.push('Введите ключ для входа')
                    return
                }

                this.errors = []
                this.isLoading = true

                this.$store.dispatch('auth/auth', {token: this.key})
                    .then(() => {
                        this.isLoading = false
                        this.redirect()
                    })
                    .catch((e) => {
                        /* eslint-disable */
                        console.error(e)
                        this.errors.push('Введите активный ключ')
                        this.isLoading = false
                    })
            },
            withoutKey () {
                if (this.isLoadingWithoutKey) return
                this.isLoadingWithoutKey = true
                this.$store.dispatch('auth/authWithoutKey')
                    .then(() => {
                        this.isLoadingWithoutKey = false
                        this.redirect()
                    })
                    .catch((e) => {
                        /* eslint-disable */
                        console.error(e)
                        this.isLoadingWithoutKey = false
                    })
            },
            redirect () {
                this.$router.push({name: 'session'})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .form-title {
        font-size 1.3rem
    }
    .form-btn {
        margin 0
        &--key {
            margin-top 1rem
            margin-left 1rem
        }
        &--free {
            width 100%
        }
        &--continue {
            width 100%
            margin-top 1rem
        }
    }
    .card {
        background #e0ebf9
    }
</style>
